module.exports = __webpack_public_path__ + "img/property1.e86415ff.png";